export default __webpack_public_path__ + "media/products/paste-a65bfd52.png";